export default {

    activeAircraft: {},

    aircraft: []
}